export default __webpack_public_path__ + "static/media/dubai.04357a49.png";